module.exports = __webpack_public_path__ + "static/assets/5a87ad00dba29bece77449d9e118f7b3.png";